import { cva } from 'class-variance-authority';

export const BUTTON_VARIANTS = cva(
  'inline-flex items-center justify-center font-semibold gap-2 transition-colors duration-200 disabled:cursor-not-allowed',
  {
    variants: {
      style: {
        filled:
          'disabled:bg-neutral-2 disabled:text-neutral-6 disabled:border disabled:border-neutral-4 dark:disabled:bg-neutral-9 dark:disabled:text-neutral-8 dark:disabled:border-neutral-8',
        outline:
          'border bg-neutral-0 disabled:text-neutral-6 disabled:border-neutral-4 dark:bg-neutral-10 disabled:bg-neutral-2 dark:disabled:bg-neutral-9 dark:disabled:text-neutral-8 dark:disabled:border-neutral-8',
        textlink:
          'border-none shadow-none disabled:text-neutral-6 disabled:no-underline dark:disabled:text-neutral-8 data-[style=textlink]:px-0 !ring-0',
      },
      buttonColor: {
        primary: '',
        neutral: '',
        error: '',
        success: '',
        warning: '',
        icon: '',
      },
      size: {
        sm: 'text-body-xs px-s h-8 data-[style=textlink]:h-5',
        default: 'text-body-sm px-base h-10 data-[style=textlink]:h-[22px]',
        lg: 'text-body-base px-base h-12 data-[style=textlink]:h-6',
      },
      borderRadius: {
        rounded: 'rounded-lg',
        soft: 'rounded-xs',
      },
    },
    compoundVariants: [
      {
        style: 'filled',
        buttonColor: 'primary',
        class:
          'bg-primary-base text-neutral-0 hover:bg-primary-dark active:bg-primary-darker data-[active=true]:bg-primary-darker focus:ring-[3px] focus:ring-primary-light',
      },
      {
        style: 'filled',
        buttonColor: 'neutral',
        class:
          'bg-neutral-3 text-neutral-9 hover:bg-neutral-4 active:bg-neutral-5 data-[active=true]:bg-neutral-5 focus:ring-[3px] focus:ring-primary-light dark:bg-neutral-7 dark:text-neutral-0 dark:hover:bg-neutral-8 dark:active:bg-neutral-9 dark:data-[active=true]:bg-neutral-9',
      },
      {
        style: 'filled',
        buttonColor: 'error',
        class:
          'bg-red-base text-neutral-0 hover:bg-red-dark active:bg-red-darker data-[active=true]:bg-red-darker focus:ring-[3px] focus:ring-primary-light',
      },
      {
        style: 'filled',
        buttonColor: 'success',
        class:
          'bg-green-dark text-neutral-0 hover:bg-green-darker active:bg-green-darkest data-[active=true]:bg-green-darkest focus:ring-[3px] focus:ring-primary-light',
      },
      {
        style: 'filled',
        buttonColor: 'warning',
        class:
          'bg-yellow-light text-neutral-9 hover:bg-yellow-base active:bg-yellow-dark data-[active=true]:bg-yellow-dark focus:ring-[3px] focus:ring-primary-light',
      },
      {
        style: 'filled',
        buttonColor: 'icon',
        class:
          'bg-primary-base text-neutral-0 hover:bg-primary-dark active:bg-primary-darker data-[active=true]:bg-primary-darker focus:ring-[3px] focus:ring-primary-light',
      },
      {
        style: 'outline',
        buttonColor: 'primary',
        class:
          'border-primary-base text-primary-base hover:bg-primary-lightest dark:hover:bg-primary-darkest active:bg-primary-lighter data-[active=true]:bg-primary-lighter dark:active:bg-primary-darker dark:data-[active=true]:bg-primary-darker focus:ring-[3px] focus:ring-primary-light dark:border-primary-light dark:text-primary-light',
      },
      {
        style: 'outline',
        buttonColor: 'neutral',
        class:
          'border-neutral-5 text-neutral-9 hover:bg-neutral-1 active:bg-neutral-3 data-[active=true]:bg-neutral-3 focus:ring-[3px] focus:ring-primary-light dark:text-neutral-5 dark:hover:bg-neutral-9 dark:active:bg-neutral-8 dark:data-[active=true]:bg-neutral-8',
      },
      {
        style: 'outline',
        buttonColor: 'error',
        class:
          'border-red-base text-red-base hover:bg-red-lightest active:bg-red-lighter data-[active=true]:bg-red-lighter focus:ring-[3px] focus:ring-primary-light dark:border-red-light dark:text-red-light dark:hover:bg-red-darkest dark:active:bg-red-darker dark:data-[active=true]:bg-red-darker',
      },
      {
        style: 'outline',
        buttonColor: 'success',
        class:
          'border-green-dark text-green-dark hover:bg-green-lightest active:bg-green-lighter data-[active=true]:bg-green-lighter focus:ring-[3px] focus:ring-primary-light dark:border-green-base dark:text-green-base dark:hover:bg-green-darkest dark:active:bg-green-darker dark:data-[active=true]:bg-green-darker',
      },
      {
        style: 'outline',
        buttonColor: 'warning',
        class:
          'border-yellow-dark text-yellow-dark hover:bg-yellow-lightest active:bg-yellow-lighter data-[active=true]:bg-yellow-lighter focus:ring-[3px] focus:ring-primary-light dark:border-yellow-base dark:text-yellow-base dark:hover:bg-yellow-darkest dark:active:bg-yellow-darker dark:data-[active=true]:bg-yellow-darker',
      },
      {
        style: 'outline',
        buttonColor: 'icon',
        class:
          'border-primary-base text-primary-base hover:bg-primary-lightest active:bg-primary-lighter data-[active=true]:bg-primary-lighter focus:ring-[3px] focus:ring-primary-light dark:border-primary-light dark:text-primary-light dark:hover:bg-primary-darkest dark:active:bg-primary-darker dark:data-[active=true]:bg-primary-darker',
      },
      {
        style: 'textlink',
        buttonColor: 'primary',
        class:
          'text-primary-base hover:text-primary-dark active:text-primary-darker data-[active=true]:text-primary-darker hover:underline active:underline focus:ring-[3px] focus:ring-primary-light dark:hover:text-primary-light dark:active:text-primary-lighter dark:data-[active=true]:text-primary-lighter',
      },
      {
        style: 'textlink',
        buttonColor: 'neutral',
        class:
          'text-neutral-9 hover:underline active:text-neutral-10 data-[active=true]:text-neutral-10 active:underline focus:ring-[3px] focus:ring-primary-light dark:text-neutral-5 dark:hover:text-neutral-4 dark:active:text-neutral-3 dark:data-[active=true]:text-neutral-3',
      },
      {
        style: 'textlink',
        buttonColor: 'error',
        class:
          'text-red-base hover:text-red-dark active:text-red-darker data-[active=true]:text-red-darker hover:underline active:underline focus:ring-[3px] focus:ring-primary-light dark:text-red-light dark:hover:text-red-lighter dark:active:text-red-lightest dark:data-[active=true]:text-red-lightest',
      },
      {
        style: 'textlink',
        buttonColor: 'success',
        class:
          'text-green-dark hover:text-green-darker active:text-green-darkest data-[active=true]:text-green-darkest hover:underline active:underline focus:ring-[3px] focus:ring-primary-light dark:text-green-base dark:hover:text-green-light dark:active:text-green-lighter dark:data-[active=true]:text-green-lighter',
      },
      {
        style: 'textlink',
        buttonColor: 'warning',
        class:
          'text-yellow-dark hover:text-yellow-darker active:text-yellow-darkest data-[active=true]:text-yellow-darkest hover:underline active:underline focus:ring-[3px] focus:ring-primary-light dark:text-yellow-base dark:hover:text-yellow-light dark:active:text-yellow-lighter dark:data-[active=true]:text-yellow-lighter',
      },
      {
        style: 'textlink',
        buttonColor: 'icon',
        class:
          'text-primary-base hover:text-primary-dark active:text-primary-darker data-[active=true]:text-primary-darker focus:ring-[3px] focus:ring-primary-light dark:hover:text-primary-light dark:active:text-primary-light dark:data-[active=true]:text-primary-light',
      },
    ],
    defaultVariants: {
      style: 'filled',
      buttonColor: 'primary',
      size: 'default',
      borderRadius: 'rounded',
    },
  },
);

export const ICON_VARIANTS = cva('inline-flex items-center', {
  variants: {
    size: {
      sm: '[&_*]:h-4 [&_*]:w-auto',
      default: '[&_*]:h-5 [&_*]:w-auto',
      lg: '[&_*]:h-6 [&_*]:w-auto',
    },
  },
});
